import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=b9f3b08a"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=b9f3b08a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports